import React from 'react';
import '../styles/footer.css'

const Footer = () => {
	return (
		<section id="footer">
			<div className="">
				<div className="row text-center text-xs-center text-sm-left text-md-left">
				</div>
				<div className="row">
					<div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-5">
						<ul className="list-unstyled list-inline social text-center">
							<li className="list-inline-item"><a href="https://www.facebook.com/pg/3PsAgency-430583477305620/posts/"><i className="fa fa-facebook"></i></a></li>
							<li className="list-inline-item"><a href="https://twitter.com/3psagency1"><i className="fa fa-twitter"></i></a></li>
							<li className="list-inline-item"><a href="https://wa.me/+27842065734" target="_blank" rel="noopener noreferrer"><i className="fa fa-whatsapp"></i></a></li>
						</ul>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-2 text-center text-white">
						<p><u><a href="About">3P'S MEDIA HOUSE</a></u> is a Registered through Companies and Intellectual Property Commission that is an agency of the Department of Trade and Industry in South Africa. </p>
						<p className="h6">© All right Reversed.<a className="text-green ml-2" href="http://capslocktechnologies.netlify.app/" target="_blank" rel="noopener noreferrer">CapsLock Technologies (Pty) Ltd</a></p>
					</div>
				</div>
			</div>
		</section>
	)
}

export default Footer